import { HttpErrorResponse } from '@angular/common/http';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators, ValidatorFn, AbstractControl, ValidationErrors  } from '@angular/forms';
// import { providerDef } from '@angular/core/src/view/provider';
import { Params, ActivatedRoute, Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import * as $ from "jquery";
import { throwError } from 'rxjs';
import { catchError, first } from 'rxjs/operators';
import {Md5} from "ts-md5/dist/md5";
import { ConfirmPasswordValidator } from '../../components/validators/validators.component';
import { VerifyCodeService } from '../../components/verifycanvas/verifyCodeService';
import { AlertService } from '../../services/alert.service';
import { UserService } from '../../services/user.service';

@UntilDestroy()
@Component({
  selector: 'app-register-confirm',
  templateUrl: './register-confirm.component.html',
  styleUrls: ['./register-confirm.component.css']
})
export class RegisterConfirmComponent implements OnInit {
  registerForm: FormGroup;
  errorId : String;
  errorMessage : String | null | undefined;
  submitted = false;
  loading = false;

  constructor(
    private route: ActivatedRoute,
    private formBuilder : FormBuilder,
    private userService: UserService,
    private alertService: AlertService,
    private readonly router: Router) {
      
  }
  
  
    get f() { return this.registerForm.controls; }
 
  ngOnInit() {

    this.registerForm = this.formBuilder.group({
      emailConfirmCode: ['', Validators.required]
  }
  );

  this.route.queryParams.subscribe(queryParams => {
    this.registerForm.controls['emailConfirmCode'].setValue(queryParams.code);
     $("#emailConfirmCode").val(queryParams.code);
  });
  
     
  }

  
 
  onSubmit() {
    this.submitted = true;
   

    // reset alerts on submit
    this.alertService.clear();

    this.registerForm.setErrors(null);
    // console.log('sssssssssssss'+this.registerForm.setErrors(null));
    // console.log('sssssssssssss'+this.registerForm.valid);
    // console.log('sssssssssssss'+this.registerForm.invalid);
    // stop here if form is invalid
    if (this.registerForm.invalid) {
        return;
    }

    this.loading = true;
    this.userService.registerConfirm(this.registerForm.value)
        .pipe(first())
        .subscribe(
            data => {
                this.alertService.success('注册邮箱验证成功!', true);
                this.router.navigate(['/login']);
            },
            (error) => {
                this.alertService.error(error.error.message);
                this.loading = false;
            });
} 
 
} 
 

